let vmId = 0;

export const guid = () => {
  let d = new Date().getTime();
  let guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function( c ){
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r&0x3|0x8)).toString(16);
  });
  return guid;
}

export const hash = ( v ) => {
  let hash = 0, i, chr;
  if (v.length === 0) return hash;
  for (i = 0; i < v.length; i++) {
    chr   = v.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export const removeTypeNamespace = ( namespace, types ) => {
  let fnLoop = ( o ) => {
    let _o = {}
    for ( let key in o ) {
      if ( typeof o[key] == "string" ) {
        _o[key] = o[key].replace(namespace, "")
      } else if ( typeof o[key] == "object" ) {
        _o[key] = fnLoop( o[key] )
      } else {
        _o[key] = o[key]
      }
    }
    return _o
  }
  return fnLoop( types )
}

export const converToCamelCase = ( str ) => {
  let arr = str.split('-')
  let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item)
  return capital.join("")
}

export const validEmail = ( email ) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return String(email).toLowerCase().match(re);
}

export const nextId = () => {
  vmId++;
  return vmId;
}
